//#region src/hooks/useRPC/types.ts
var RPCCacheStrategy = {
	cacheFirst: "cache-first",
	cacheOnly: "cache-only",
	remoteFirst: "remote-first",
	remoteOnly: false
};
//#endregion
export { RPCCacheStrategy };

//# sourceMappingURL=types.js.map